import { Component, OnInit } from '@angular/core';
import { NgbActiveModal, NgbTooltip } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-reset-check-modal',
  templateUrl: './reset-check-modal.component.html',
  styleUrls: ['./reset-check-modal.component.scss'],
  imports: [TranslatePipe, NgbTooltip]
})
export class ResetCheckModalComponent implements OnInit {
  public entity: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
